import { useState } from "react";

import useService from "../../../../hooks/useService";
import { getModalHandler } from "../../Common/Modals/hooks/useModalSingleton";

export default function usePaymentsEventHandlers({ fetchPaymentsData, setCurrentPage }) {
  const paymentsRepository = useService("repositories/payment-repository");
  const { openFailureModal, openSuccessModal } = getModalHandler();
  const [modalState, setModalState] = useState({ mode: "", payment: null });
  const [isDeleting, setIsDeleting] = useState(false);

  const handlePageChange = (_, newPage) => setCurrentPage(newPage);
  const handleOpenAddModal = () => setModalState({ mode: "add", payment: null });
  const handleOpenEditModal = (payment) => setModalState({ mode: "edit", payment });
  const handleOpenDeleteModal = (payment) => setModalState({ mode: "delete", payment });
  const handleCloseModal = () => setModalState({ mode: "", payment: null });
  const handleDelete = async () => {
    const paymentId = modalState.payment?.id;

    if (!paymentId) {
      return;
    }

    try {
      setIsDeleting(true);
      await paymentsRepository.delete(paymentId);
      await fetchPaymentsData?.();
      handleCloseModal();
      openSuccessModal();
    } catch (error) {
      openFailureModal(error);
    } finally {
      setIsDeleting(false);
    }
  };

  return {
    modalState,
    isDeleting,
    handleDelete,
    handlePageChange,
    handleOpenAddModal,
    handleOpenEditModal,
    handleOpenDeleteModal,
    handleCloseModal,
  };
}

export function usePaymentsRowMenuHandlers({ data, onDelete, onEdit }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const handleEdit = () => {
    handleMenuClose();
    onEdit?.(data);
  };
  const handleDelete = () => {
    handleMenuClose();
    onDelete?.(data);
  };

  return {
    anchorEl,
    menuOpen,
    handleEdit,
    handleDelete,
    handleMenuOpen,
    handleMenuClose,
  };
}
